import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { GzResumeIntegrityMonitorWebComponent } from './component/GzResumeIntegrityMonitorWebComponent';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';

export class ResumeIntegrityMonitoringPopUp extends NetworkBasePopUp<GzResumeIntegrityMonitorWebComponent> {
  protected transformToTaskTarget = true;
  protected title = translateFn('Resume integrity monitoring');
  protected extraDialogConfigs = {
    isWindow: false,
  };

  protected customSetup() {
    this.popUpContent = new GzResumeIntegrityMonitorWebComponent();
  }

  protected handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload: CreateTaskRequest = {
      settings: {
        targets: this.data.targets || [],
        taskName: translateFn('Resume Integrity Monitoring task ') + getFormattedDateForTask(),
        type: Constants.Tasks.Endpoints.TASK_TYPE_RESUME_INTEGRITY_MONITORING_PARENT,
      },
    };

    return this.createTask(payload);
  }
}
